const en = {
  nav: { about: "About", services: "Services", logistics: "Logistics", clients: "Clients", news: "News", contact: "Contact", cta: "Book a consultation", menu: "Menu", close: "Close" },
  global: {
    eyebrow: "The world in motion",
    title: "From the Coast to the _great capitals_.",
    intro: "People making deals, goods on the move: this is the world we work in every day.",
    capitals: "Great capitals",
    deals: "People & deals",
    base: "My base: the Coast",
    ops: "Goods on the move",
    timezones: "Time zones",
    newsTicker: "World news · always up to date · read further down in News & Markets",
  },
  news: {
    eyebrow: "06 — News & Markets",
    title: "The world of freight, _in real time_.",
    intro: "Headlines updated automatically from leading international logistics portals.",
    read: "Read",
    updated: "Updated",
  },
  hero: {
    eyebrow: "Business consulting · Import Export · Logistics",
    lines: ["Moving", "businesses", "_beyond_ borders."],
    sub: "We support companies in import-export, documentation procedures, market entry and international logistics: from the first contact to final delivery.",
    cta: "Let's talk about your project",
    cta2: "Explore services",
    scroll: "Scroll",
    tags: ["Sea", "Air", "Road", "Courier"],
    frame: "Global routes, one single partner",
  },
  marquee: ["Import · Export", "Documentation procedures", "Temperature controlled", "Dangerous goods DGR", "Ocean freight", "Air cargo", "Road transport", "Warehousing & packaging", "Market development"],
  about: {
    eyebrow: "01 — About",
    title: "One consultant, one network, _one method_ to grow abroad.",
    body1: "MF Logistics Consulting Group was created to give companies a single point of reference when they decide to sell, buy or produce beyond national borders.",
    body2: "We combine documentation expertise, market knowledge and logistics operations to turn an expansion idea into a real flow of goods, contracts and relationships.",
  founderRole: "Founder & CEO",
  founderLine: "Years of international experience across Europe and beyond: I guide companies across borders, with care and method.",
  doorCaption: "My door is always open",
    pillars: [
      { t: "The full picture", d: "Commercial strategy, paperwork and transport handled as one project." },
      { t: "Hands-on execution", d: "We follow every shipment and every file through to completion." },
      { t: "Network of contacts", d: "Selected partners, suppliers and buyers in your target markets." },
    ],
  },
  services: {
    eyebrow: "02 — Services",
    title: "Tailored consulting, _from paperwork_ to container.",
    intro: "Every company is different: we design the path that fits yours.",
    items: [
      { t: "Import & Export", d: "Flow planning, Incoterms, suppliers and logistics partners to buy and sell abroad safely." },
      { t: "Documentation procedures", d: "Customs files, certificates of origin, transport documents and regulatory compliance handled with precision." },
      { t: "Product market entry", d: "Target market analysis, entry requirements and launch strategy for your products." },
      { t: "Business development abroad", d: "Internationalisation plans and commercial growth in new countries and channels." },
      { t: "Contact development", d: "Sourcing and qualifying buyers, distributors and partners in your market of interest." },
      { t: "Order requests from foreign markets", d: "Sourcing international clients and handling their order requests, from first contact to confirmed order." },
      { t: "Business consulting", d: "Support on organisation, processes and any other need related to your business." },
    ],
  },
  logistics: {
    eyebrow: "03 — Logistics",
    title: "Any cargo, _any_ route.",
    intro: "We organise end-to-end shipments for every type of goods and transport mode, including warehousing and packaging.",
    modesTitle: "Transport modes",
    modesDesc: "We combine sea, air, road and courier to strike the right balance between time, cost and safety.",
    modes: ["Sea", "Air", "Road", "Courier"],
    goodsTitle: "Types of goods",
    goods: [
      { t: "Ambient temperature — General cargo", d: "General cargo, groupage and full loads." },
      { t: "Temperature controlled", d: "Cold chain and dedicated temperature ranges." },
      { t: "Dangerous goods DGR", d: "Documentation and handling under ADR / IMDG / IATA." },
    ],
    subsLabel: "Load sub-categories",
    subs: ["Food & perishables (incl. frozen)", "Pharmaceuticals", "Machinery & machines", "Luxury goods", "Clothing", "Cosmetics", "…and more"],
    insurance: { t: "Cargo insurance", d: "Full protection for your goods on every leg." },
    docsPermits: { t: "Documents & permits", d: "Registrations, health certificates, entry permits and every filing." },
    palletControl: { t: "Palletization & control", d: "Storage, palletization and goods inspection in warehouse." },
    warehousing: { t: "Warehousing", d: "Storage, stock management and distribution." },
    packaging: { t: "Packaging", d: "Packaging suited to goods, mode and regulations." },
    customs: { t: "Documents & customs", d: "From bill of lading to certificate: every paper in place." },
  },
  newsletter: {
    eyebrow: "The newsletter",
    titleAccent: "Stay up to date",
    title: " with the world.",
    sub: "Once a month: routes, markets and practical tips to sell and buy across borders. No spam.",
    placeholder: "Your email",
    cta: "Subscribe",
    sending: "Sending…",
    ok: "Subscription confirmed! You will receive our news.",
    already: "You are already subscribed.",
    error: "Something went wrong. Please try again.",
    privacy: "By subscribing you agree to receive our updates. No spam: unsubscribe anytime.",
  },
  clients: {
    eyebrow: "04 — Clients",
    title: "Companies that chose _our services_.",
    intro: "Some of the businesses we have supported on international markets.",
    consTitle: "With _consulting_.",
    impTitle: "With _import-export_.",
    placeholder: "[Client logo]",
    visit: "Visit",
  },
  contact: {
    eyebrow: "05 — Contact",
    title: "Tell us _where_ you want to go.",
    intro: "Write to us: we'll get back to you to define the best path together.",
    fields: { name: "Full name", company: "Company", email: "Email", phone: "Phone", service: "What do you need?", message: "Message" },
    servicePick: "Select a service",
    logisticsOption: "Shipping & logistics",
    submit: "Send request",
    sending: "Sending…",
    success: "Thank you! We've received your request and will contact you shortly.",
    error: "Sending failed. Please check the fields and try again.",
    direct: "Direct contact",
    emailLabel: "Email",
    phoneLabel: "Phone",
    vatLabel: "VAT no.",
    addressLabel: "Office",
  },
  footer: { tagline: "Business consulting, import-export and international logistics.", rights: "All rights reserved.", admin: "Admin area", top: "Back to top" },
};
export default en;
